import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PickerItemComponent } from './components/picker-item/picker-item.component';
import {LibLazyImageModule} from '@components/image/modules/lazy-image/lib-lazy-image.module';
import { PickerSliderComponent } from './components/picker-slider/picker-slider.component';
import {LibSliderModule} from '@lib-modules/slider/lib-slider.module';
import {CoreModule} from '@core/core.module';



@NgModule({
  declarations: [
    PickerItemComponent,
    PickerSliderComponent
  ],
  exports: [
    PickerItemComponent,
    PickerSliderComponent
  ],
  imports: [
    CommonModule,
    LibLazyImageModule,
    LibSliderModule,
    CoreModule
  ]
})
export class PickerModule { }
